import {StoreType} from '..';
import {IUserOrganizationSettingData} from '@/utils/types';

export const adminNotificationSettingSelector = (state: StoreType): IUserOrganizationSettingData | null =>
	state.adminNotificationStore.adminSetting;
